<tt-page class="col-xs-12 col-md-6 sp-0">
    <tt-card>
        <tt-tabs [(ttSelectedId)]="selectedBgVisited" (ttSelectedIdChange)="onTabChangeVisited()">
            <tt-tab ttId="IN" ttLabel="in"></tt-tab>
            <tt-tab ttId="OUT" ttLabel="out"></tt-tab>
        </tt-tabs>

        <div *ngIf="selectedBgVisited === 'IN'">
            <form class="form-horizontal sp-0" name="formVisitorSearch" novalidate (ngSubmit)="searchItems()" method="get" role="form">
                <tt-input ttLabel="visitor_search" ttFocus="true" [(ttModel)]="personName" (ttModelChange)="onChanged($event, 'personName')" [ttButtons]="personNameButtons"></tt-input>
            </form>

            <tt-button ttText="search" (ttClick)="searchBtn()" [ttSpin]="searchingFromBtn" ttIcon="fas fa-sync"></tt-button>
        </div>
    </tt-card>

    <tt-list *ngIf="selectedBgVisited === 'IN'" [ttData]="itemsListPersons"></tt-list>
    <tt-list *ngIf="selectedBgVisited === 'OUT'" [ttData]="itemsListCheckOuts"></tt-list>
</tt-page>
